export default "__VITE_ASSET__BTe9zDwH__"